<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!isEditing) {
    <div class="row">
      @if (currentStateIndex) {
        <div class="col-2">
          <div class="content-container h-100">
            <div class="title pb-0 d-flex justify-content-center text-uppercase">
              <mwp-text-translate text="States" jsonKey="states" />
            </div>
            <div class="content">
              @for (stateTaxIndex of memberStateTaxes.stateTaxIndexModels; track stateTaxIndex) {
                <div class="menu-block" [ngClass]="{'selected-menu-block': stateTaxIndex.code == currentStateIndex.code}">
                  <button id="i" (click)="changeStateSelection(stateTaxIndex)" [class.active]="stateTaxIndex.code == currentStateIndex.code">
                    <div class="select-left-tab">
                      @if (!stateTaxIndex.haveChangeRequest) {
                        <div class="no-format"></div>
                      }
                      @if (stateTaxIndex.haveChangeRequest) {
                        <div class="circle-container-orange">
                          <div class="circle-orange"></div>
                        </div>
                      }
                    </div>
                    <div class="select-right-tab">
                      <span class="text-uppercase">
                        {{stateTaxIndex.name}}
                      </span>
                    </div>
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (displayStateTaxForm) {
        <div class="col-10">
          @if (currentStateTax.noStateTax) {
            <div class="message-container blue-fill text-centered">
              {{currentStateIndex.name}}
              <mwp-text-translate text="does not have taxes!" jsonKey="currentStateNoTaxes" />
            </div>
          }
          @if (!currentStateTax.noStateTax) {
            <div>
              @if (currentStateTax.id < 0) {
                <div class="mb-4 message-container blue-fill text-centered">
                  <mwp-text-translate text="You do not currently have any saved Tax information for " jsonKey="currentStateNoCurrentTaxes" />
                  {{currentStateIndex.name}}
                </div>
              }
              @if (currentStateTax.id > 0) {
                <div>
                  <mwp-state-tax-form title="State Taxes" [stateTax]="currentStateTax" [isEditing]="false" />
                </div>
              }
            </div>
          }
          @if (displayTopRequestButton) {
            <div class="d-flex justify-content-end mb-3">
              <button class="mwp-button" (click)="newChangeRequest()">
                <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
              </button>
            </div>
          }
          @if (displayPendingOrDeniedRequest) {
            <div class="mb-3">
              <mwp-state-tax-form [title]="pendingOrDeniedHeader" [changeRequestStateTax]="currentChangeRequestStateTax" [isEditing]="false" />
            </div>
          }
          @if (!displayTopRequestButton) {
            <div class="d-flex justify-content-end">
              <button class="mwp-button" (click)="editChangeRequest()">
                <mwp-text-translate [text]="buttonText" [jsonKey]="buttonText" />
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (isEditing) {
    <div>
      <mwp-state-tax-form title="New Change Request" [changeRequestStateTax]="changeRequestFormModel" [isEditing]="true" (cancelEmit)="cancelEdit($event)" />
    </div>
  }
</div>